import _implicitStylesheets from "./ratingSummary.css";
import _implicitScopedStylesheets from "./ratingSummary.scoped.css?scoped=true";
import _wdsStarRatings from "wds/starRatings";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "summary-reviews": true
  },
  attrs: {
    "grid": "",
    "axis": "row"
  },
  key: 0
};
const stc1 = {
  classMap: {
    "rating-stars": true
  },
  key: 1
};
const stc2 = {
  slotAssignment: "label",
  classMap: {
    "label": true
  },
  attrs: {
    "type-style": "body-3"
  },
  key: 3
};
const stc3 = {
  attrs: {
    "name": "label"
  },
  key: 4
};
const stc4 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {s: api_slot, h: api_element, c: api_custom_element} = $api;
  return [api_element("div", stc0, [api_element("div", stc1, [api_custom_element("wds-star-ratings", _wdsStarRatings, {
    props: {
      "value": $cmp.averageRating,
      "readOnly": true,
      "size": "medium",
      "spaceBetween": $cmp.starSpaceBetween,
      "labelPosition": $cmp.labelPosition
    },
    key: 2
  }, [api_element("span", stc2, [api_slot("label", stc3, stc4, $slotset)])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["label"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2jngj1tfi6v";
tmpl.legacyStylesheetToken = "undefined-_ratingSummary";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
